import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RestDataService} from '../../../services/rest-data.service';
import {SmallSelectItem} from '../../../services/common-datatypes';
import {RequiredInput} from '../../../decorators/common.decorators';
import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-ownership-select',
    templateUrl: './ownership-select.component.html',
    styleUrls: ['./ownership-select.component.scss']
})
export class OwnershipSelectComponent {

    public selectList: SmallSelectItem[] = [];
    @Input() translationPrefix = 'select.ownership';
    @Input() inline = false;
    @Input() autoOpen = false;
    @Input() multiple = false;
    @Input() allowEmpty = true;
    @Input() @RequiredInput selectedItems!: SmallSelectItem[];
    @Output() selectedItemsChange = new EventEmitter<SmallSelectItem[]>();

    constructor(private translate: TranslateService,
                private dataService: RestDataService) {
        _('select.ownership.name'); // ngx-translate-extract
        _('select.ownership.all'); // ngx-translate-extract
        this.loadData();
    }

    loadData() {
        if (0 === this.selectList.length) {
            this.dataService.getOwnership().then((data: SmallSelectItem[]) => {
                if (data && (0 < data.length)) {
                    data.forEach((item) => {
                        const newItem = new SmallSelectItem();
                        newItem.updateFromJson(item);
                        this.translate.get('ownership.' + item.name).subscribe(
                            (trans: string) => newItem.name = trans
                        );
                        this.selectList.push(newItem);
                    });
                }
            });
        }
    }

    updateData() {
        this.selectedItemsChange.emit(this.selectedItems);
    }

}
